import {
  AssignmentType,
  HomeAssignment,
  ProgressStatus,
  UserAssignmentsMode,
} from "../services/api/types/general/homeAssignment";

export const mockCourses: HomeAssignment[] = [
  {
    assignmentId: "ha1",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Introduction to TypeScript",
    thumbnail: "/images/typescript.png",
    progress: 0,
    duration: "15m",
    dueDate: "2026-03-01",
    progressStatus: ProgressStatus.NOTSTARTED,
    assignmentType: AssignmentType.COURSE,
    courseCount: 1,
    policyCount: 0,
    surveyCount: 0,
  },
  {
    assignmentId: "ha2",
    isDirectAssignment: false,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Company Policy Overview",
    titleShort: "Policy Overview",
    thumbnail: "/images/policy.png",
    progress: 0,
    duration: "5m",
    dueDate: "2026-02-20",
    progressStatus: ProgressStatus.NOTSTARTED_OVERDUE,
    assignmentType: AssignmentType.POLICY,
    courseCount: 0,
    policyCount: 1,
    surveyCount: 0,
  },
  {
    assignmentId: "ha3",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "JavaScript Basics Quiz",
    thumbnail: "/images/js_quiz.png",
    progress: 40,
    duration: "10m",
    dueDate: "2026-02-28",
    progressStatus: ProgressStatus.INPROGRESS,
    assignmentType: AssignmentType.COURSE,
    courseCount: 1,
    policyCount: 0,
    surveyCount: 0,
  },
  {
    assignmentId: "ha4",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Workplace Safety Survey",
    thumbnail: "/images/survey.png",
    progress: 20,
    duration: "8m",
    dueDate: "2026-03-02",
    progressStatus: ProgressStatus.INPROGRESS,
    assignmentType: AssignmentType.SURVEY,
    courseCount: 0,
    policyCount: 0,
    surveyCount: 1,
  },
  {
    assignmentId: "ha5",
    isDirectAssignment: false,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Advanced CSS Techniques",
    thumbnail: "/images/css.png",
    progress: 100,
    duration: "20m",
    dueDate: "2026-02-25",
    progressStatus: ProgressStatus.COMPLETED,
    assignmentType: AssignmentType.COURSE,
    courseCount: 2,
    policyCount: 1,
    surveyCount: 0,
  },
  {
    assignmentId: "ha6",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "React Fundamentals",
    thumbnail: "/images/react.png",
    progress: 0,
    duration: "25m",
    dueDate: "2026-03-10",
    progressStatus: ProgressStatus.NOTSTARTED,
    assignmentType: AssignmentType.COURSE,
    courseCount: 3,
    policyCount: 0,
    surveyCount: 0,
  },
  {
    assignmentId: "ha7",
    isDirectAssignment: false,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Company Handbook",
    thumbnail: "/images/handbook.png",
    progress: 50,
    duration: "30m",
    dueDate: "2026-03-15",
    progressStatus: ProgressStatus.INPROGRESS,
    assignmentType: AssignmentType.POLICY,
    courseCount: 0,
    policyCount: 1,
    surveyCount: 0,
  },
  {
    assignmentId: "ha8",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "TypeScript Quiz",
    thumbnail: "/images/ts_quiz.png",
    progress: 75,
    duration: "12m",
    dueDate: "2026-03-03",
    progressStatus: ProgressStatus.INPROGRESS,
    assignmentType: AssignmentType.COURSE,
    courseCount: 2,
    policyCount: 0,
    surveyCount: 0,
  },
  {
    assignmentId: "ha9",
    isDirectAssignment: false,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Customer Feedback Survey",
    thumbnail: "/images/customer_survey.png",
    progress: 100,
    duration: "10m",
    dueDate: "2026-02-20",
    progressStatus: ProgressStatus.COMPLETED,
    assignmentType: AssignmentType.SURVEY,
    courseCount: 0,
    policyCount: 0,
    surveyCount: 1,
  },
  {
    assignmentId: "ha10",
    isDirectAssignment: true,
    mode: UserAssignmentsMode.ENROLLED,
    title: "Node.js Backend Basics",
    thumbnail: "/images/node.png",
    progress: 30,
    duration: "40m",
    dueDate: "2026-03-12",
    progressStatus: ProgressStatus.INPROGRESS,
    assignmentType: AssignmentType.COURSE,
    courseCount: 2,
    policyCount: 0,
    surveyCount: 0,
  },
];
